import { useLocation } from "react-router-dom";
import { AuthProvider } from "./AuthProvider";
import { DrawerProvider } from "./DrawerProvider";
import { SessionProvider } from "./SessionProvider";
import { StickyBarProvider } from "./StickyBarProvider";
import AuthHealthReporter from "../components/auth/AuthHealthReporter";

export const APP_RUNTIME_MODES = Object.freeze({
  firestoreFreePublic: "firestore-free-public",
  fullApp: "full-app",
});

const FIRESTORE_FREE_PUBLIC_ROUTE_PATTERNS = [
  {
    id: "parent-authorization",
    pattern: /^\/parent-authorization\/?$/u,
  },
  {
    id: "hiring-public-seo",
    pattern: /^\/hiring(?:\/(?:locations|[a-z0-9-]+(?:\/[a-z0-9-]+)?))?\/?$/u,
  },
];

export const normalizeRuntimePathname = (pathname = "") => {
  const normalizedPath = String(pathname || "/").split(/[?#]/u, 1)[0] || "/";
  return normalizedPath.startsWith("/") ? normalizedPath : `/${normalizedPath}`;
};

export const isFirestoreFreePublicRoute = (pathname = "") => {
  const normalizedPath = normalizeRuntimePathname(pathname);
  return FIRESTORE_FREE_PUBLIC_ROUTE_PATTERNS.some(({ pattern }) =>
    pattern.test(normalizedPath),
  );
};

export const getAppRuntimeMode = (pathname = "") =>
  isFirestoreFreePublicRoute(pathname)
    ? APP_RUNTIME_MODES.firestoreFreePublic
    : APP_RUNTIME_MODES.fullApp;

function AppRuntimeProviders({ children }) {
  const location = useLocation();
  const runtimeMode = getAppRuntimeMode(location.pathname);
  const firestoreFreePublicRoute =
    runtimeMode === APP_RUNTIME_MODES.firestoreFreePublic;

  if (firestoreFreePublicRoute) {
    return (
      <StickyBarProvider>
        <DrawerProvider>{children}</DrawerProvider>
      </StickyBarProvider>
    );
  }

  return (
    <AuthProvider>
      <SessionProvider>
        <AuthHealthReporter />
        <StickyBarProvider>
          <DrawerProvider>{children}</DrawerProvider>
        </StickyBarProvider>
      </SessionProvider>
    </AuthProvider>
  );
}

export default AppRuntimeProviders;
